import { device } from "helpers/_device";

import trans from "helpers/_translation";

const BORDER = "#e9e9e9";

const BLUE = "#1B84FF";
const GREEN = "#17C653";
const ORANGE = "#ff964f";
const YELLOW = "#F4C435";
const RED = "#F8285A";
const PURPLE = "#721BFF";

const COLORS = [BLUE, GREEN, PURPLE, ORANGE, YELLOW, RED];

export const getOptions = (type = "default") => {
	const options = {
		"chart": {"fontFamily": "inherit", "type": "bar", "toolbar": {"show": false}},
		"plotOptions": {
			"bar": {
				horizontal: false,
				columnWidth: "30%",
				borderRadius: 5,
				borderRadiusApplication: 'end'
			}
		},
		"legend": {"show": false},
		"dataLabels": {"enabled": false},
		"stroke": {"show": true, "width": 2, "colors": ["transparent"]},
		"xaxis": {
			"axisBorder": {"show": false},
			"axisTicks": {"show": false},
			"labels": {"style": {"colors": "inherit", "fontSize": "14px"}}
		},
		"yaxis": {"labels": {"style": {"colors": "inherit", "fontSize": "14px"}}},
		"fill": {"opacity": 1},
		"states": {
			"normal": {"filter": {"type": "none", "value": 0}},
			"hover": {"filter": {"type": "none", "value": 0}},
			"active": {"allowMultipleDataPointsSelection": false, "filter": {"type": "none", "value": 0}}
		},
		"tooltip": {"style": {"fontSize": "14px"}, "y": {}},
		"colors": COLORS,
		"grid": {"borderColor": BORDER, "strokeDashArray": 4, "yaxis": {"lines": {"show": true}}}
	};
	return options;
};